import { motion } from "framer-motion";

export default function Sparkline({ data, positive }) {
  if (!data || data.length < 2) return <span className="hidden h-9 w-28 sm:block" />;
  const w = 112;
  const h = 36;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const d = data
    .map((v, i) => {
      const x = ((i / (data.length - 1)) * w).toFixed(1);
      const y = (h - ((v - min) / range) * (h - 4) - 2).toFixed(1);
      return `${i === 0 ? "M" : "L"}${x} ${y}`;
    })
    .join(" ");
  const color = positive ? "#00FF41" : "#FF003C";
  const glow = positive
    ? "drop-shadow(0 0 6px rgba(0,255,65,0.45))"
    : "drop-shadow(0 0 6px rgba(255,0,60,0.45))";
  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="hidden h-9 w-28 sm:block" aria-hidden="true">
      <motion.path
        d={d}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
        initial={{ pathLength: 0 }}
        whileInView={{ pathLength: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.4, ease: "easeInOut" }}
        style={{ filter: glow }}
      />
    </svg>
  );
}
